import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { Helmet } from 'react-helmet';
import Moment from 'react-moment';
import { tzFormat } from '../../common/dates';
import { RedCircle, ConnectionOverlay } from 'components/WebSocketIndicator/WebSocketIndicator.styles';

const IS_EARLY_SECONDS = 4;

export const WebSocketIndicatorView = ({ connected, disconnectionTimestamp, reconnect, isWebSocketEnabled }) => {
    const [allowRendering, setAllowRendering] = useState(false);
    const [timeOutRunning, setTimeOutRunning] = useState(false);

    const isItTooEarlyToRender = () => {
        if (!connected && disconnectionTimestamp) {
            const fromNowSeconds = moment().diff(moment(disconnectionTimestamp), 'seconds');
            return fromNowSeconds <= IS_EARLY_SECONDS;
        }
        return false;
    };

    useEffect(() => {
        if (isItTooEarlyToRender() && !timeOutRunning) {
            setAllowRendering(false);
            setTimeOutRunning(true);

            const timeoutId = setTimeout(() => {
                setAllowRendering(true);
                setTimeOutRunning(false);
            }, (IS_EARLY_SECONDS + 1) * 1000);

            return () => clearTimeout(timeoutId); // Clean up the timeout on unmount or rerender
        }
    }, [timeOutRunning]);

    if (!allowRendering) {
        return null;
    }

    if (!connected && disconnectionTimestamp && isWebSocketEnabled) {
        return (
            <ConnectionOverlay>
                <div>
                    <RedCircle /> Real-time connection lost{' '}
                    <Moment fromNow title={tzFormat(disconnectionTimestamp, 'dddd, MMMM Do YYYY [at] HH:mm ')}>
                        {disconnectionTimestamp}
                    </Moment>
                    {reconnect && '. Reconnecting ...'}
                </div>
                <Helmet>
                    <title>...reconnecting</title>
                </Helmet>
            </ConnectionOverlay>
        );
    }

    return null;
};
